import { paths } from '../../../../../common/constants/pathVariables';
import { elisaKukaSoittaaMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { KukaSoittaaOrder } from '../../../../../components/KukaSoittaaOrder/KukaSoittaaOrder';

export const OrderMobileVoiceAddOnsPath = () => (
  <KukaSoittaaOrder
    breadCrumbs={[
      { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
      { name: t.ZKZZ(elisaKukaSoittaaMsg) },
    ]}
  />
);
